import { useEffect, useState } from 'react'

type DisplayType = 'mobile' | 'tablet' | 'laptop' | 'large'

export const useMediaQuery = () => {
  const [displayType, setDisplayType] = useState<DisplayType | null>(null)

  useEffect(() => {
    const mobileMediaQeury = window.matchMedia('(max-width: 767px)')
    if (mobileMediaQeury.matches) {
      setDisplayType('mobile')
    } else {
      const tabletMediaQeury = window.matchMedia('(max-width: 999px)')
      if (tabletMediaQeury.matches) {
        setDisplayType('tablet')
      } else {
        const laptopMediaQeury = window.matchMedia('(min-width: 1279px)')
        if (laptopMediaQeury.matches) {
          setDisplayType('laptop')
        } else {
          setDisplayType('large')
        }
      }
    }
  }, [])

  return displayType
}
